import axiosInstance from './axios';

export interface FactusMunicipality {
    id: string; // ID interno de Factus
    name: string;
    department: string;
    code: string; // Codigo DANE
}

export const searchFactusMunicipalities = async (query: string): Promise<FactusMunicipality[]> => {
    const response = await axiosInstance.get<FactusMunicipality[]>(`/factus/municipalities?name=${query}`);
    return response.data;
};
